module.exports = __webpack_public_path__ + "assets/img/living_5-3.2ec54e92.jpg";